/* Nutty — pretplata na pakete (v5, 27.8.2026)

   Pretplata NE dodaje bundle varijantu (Shopify to odbija s 422), nego
   komponente paketa, svaku sa selling planom i propertyjem 'Paket'.

   STO JE DINAMICNO (cita se sa Shopifyja pri svakom otvaranju stranice):
   - id selling plana        — iz product.selling_plan_groups
   - naziv plana i grupe     — isto
   - pretplatnicka cijena    — selling_plan_allocations[].price po barici
   - postotak popusta        — racuna se iz stvarnih cijena
   - ljestvica popusta       — iz plan.price_adjustments
   - redovna cijena paketa   — product.price

   STO JE ZAKOVANO (mijenja se samo rucno, ovdje u PACKS):
   - sastav paketa: koje barice i koliko komada po paketu
   - id varijanti barica i njihovi handleovi
   Ako se u Bundles appu promijeni sastav paketa, treba ga promijeniti i tu. */
(function () {
  'use strict';

  var PLAN_ID_FALLBACK = 691974046039;   // koristi se samo ako se plan ne procita
  var planId = PLAN_ID_FALLBACK;
  var PROP = 'Paket';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // handle -> { title, items: [ [variantId, kolicina po paketu, naziv] ] }
  var PACKS = {
    'bee-green-mix':        { title: 'Bee & Green Mix', items: [[51804056813911,6,'Bee original'],[51804070216023,6,'Green is in']] },
    'honey-date-mix':       { title: 'Honey Date Mix', items: [[51804056813911,6,'Bee original'],[51804073656663,6,"It's a date"]] },
    'cacao-mix':            { title: 'Cacao Mix', items: [[51804079259991,6,'Better together'],[51804081258839,6,'Dreamy Hazel']] },
    'nutty-honey-mix-12-kom': { title: 'Nutty Honey mix', items: [[51804056813911,6,'Bee original'],[51804079259991,6,'Better together']] },
    'vegan-mix-12-kom':     { title: 'Nutty Vegan mix', items: [[51804070216023,6,'Green is in'],[51804073656663,6,"It's a date"]] },
    'nutty-love-mix':       { title: 'Nutty Love mix', items: [[51804079259991,6,'Better together'],[51804073656663,6,"It's a date"]] },
    'nutty-barica-bee-original-12-kom': { title: 'Bee Original', items: [[51804056813911,12,'Bee original']] },
    'nutty-barica-green-is-in-12-kom':  { title: 'Green is in', items: [[51804070216023,12,'Green is in']] },
    'nutty-barica-its-a-date-12-kom':   { title: "It's a date", items: [[51804073656663,12,"It's a date"]] },
    'nutty-barica-better-together-12-kom': { title: 'Better together', items: [[51804079259991,12,'Better together']] },
    'dreamy-hazel-12-kom':  { title: 'Dreamy Hazel', items: [[51804081258839,12,'Dreamy Hazel']] },
    'try-them-all':         { title: 'Try them all', items: [[51804056813911,6,'Bee original'],[51804079259991,6,'Better together'],[51804070216023,6,'Green is in'],[51804073656663,6,"It's a date"],[52969054994775,1,'Dreamy Hazel GRATIS']] },
    'family-pack':          { title: 'Family Pack', items: [[51804056813911,12,'Bee original'],[51804079259991,6,'Better together'],[51804081258839,6,'Dreamy Hazel'],[51804070216023,6,'Green is in'],[51804073656663,6,"It's a date"]] }
  };

  var VARIANT_HANDLE = {
    51804056813911: 'nutty-barica-bee-original',
    51804070216023: 'nutty-barica-green-is-in',
    51804073656663: 'nutty-barica-its-a-date',
    51804079259991: 'nutty-barica-better-together',
    51804081258839: 'nutty-barica-dreamy-hazel',
    52969054994775: 'nutty-barica-dreamy-hazel-gratis'
  };

  var nativeFetch = window.fetch.bind(window);
  var packForm = null, optBox = null, activePack = null, cart = null;
  var productCache = {};

  function handleFromPath() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat('hr-HR', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function subSelected() {
    var i = optBox && optBox.querySelector('input[value="sub"]');
    return !!(i && i.checked);
  }

  window.NuttyAdd = window.NuttyAdd || {};
  window.NuttyAdd.subscriptionActive = function (form) {
    return !!(packForm && form === packForm && subSelected());
  };

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = nativeFetch(ROOT + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); });
    return productCache[handle];
  }

  /* cijena jedne barice: lista + pretplatnicka, onako kako ih Shopify objavljuje */
  function unitPrices(variantId) {
    var h = VARIANT_HANDLE[variantId];
    if (!h) return Promise.resolve(null);
    return getProduct(h).then(function (p) {
      var vs = p.variants || [];
      var v = null;
      for (var i = 0; i < vs.length; i++) { if (vs[i].id === variantId) { v = vs[i]; break; } }
      if (!v) v = vs[0];
      if (!v) return null;
      var alloc = null;
      (v.selling_plan_allocations || []).forEach(function (a) {
        if (a.selling_plan_id === planId) alloc = a;
      });
      return { list: v.price, sub: alloc ? alloc.price : null };
    }).catch(function () { return null; });
  }

  /* ---------------- 1. PDP: opcije kupovine ---------------- */

  function initPdp() {
    var handle = handleFromPath();
    if (!handle || !PACKS[handle]) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.nuttyReady) return;
    form.dataset.nuttyReady = '1';
    packForm = form;
    activePack = PACKS[handle];

    getProduct(handle).then(function (product) {
      var group = (product.selling_plan_groups || [])[0];
      var plan = group && group.selling_plans && group.selling_plans[0];
      if (plan && plan.id) planId = plan.id;      /* <- plan se cita, ne pogadja */
      return Promise.all(activePack.items.map(function (it) {
        return unitPrices(it[0]).then(function (u) { return { qty: it[1], naziv: it[2], u: u }; });
      })).then(function (rows) { render(form, product, activePack, rows); });
    }).catch(function () {});
  }

  function render(form, product, pack, rows) {
    var group = (product.selling_plan_groups || [])[0];
    var plan = group && group.selling_plans && group.selling_plans[0];

    var one = product.price;
    var listSum = 0, subSum = 0, ok = !!plan;
    rows.forEach(function (r) {
      if (!r.u || r.u.sub === null || r.u.sub === undefined) { ok = false; return; }
      listSum += r.u.list * r.qty;
      subSum += r.u.sub * r.qty;
    });

    if (ok && listSum !== one) {
      ok = false;
      if (window.console) {
        console.warn('[nutty] ' + pack.title + ': zbroj barica ' + listSum +
          ' ≠ cijena paketa ' + one + ' — pretplata sakrivena (treba automatski popust).');
      }
    }

    var sadrzaj = pack.items.map(function (i) { return i[1] + '× ' + i[2]; }).join(' + ');
    var ladder = '';
    if (plan) {
      ladder = (plan.price_adjustments || []).map(function (a) {
        if (a.value_type !== 'percentage') return null;
        return a.order_count
          ? 'prve ' + a.order_count + ' dostave −' + a.value + '%'
          : 'zatim −' + a.value + '%';
      }).filter(Boolean).join(', ');
    }

    var box = document.createElement('div');
    box.className = 'nutty-po';
    var html =
      '<div class="nutty-po__title">Opcije kupovine</div>' +
      '<label class="nutty-po__opt is-active">' +
        '<input type="radio" name="nutty-mode" value="onetime" checked>' +
        '<span class="nutty-po__label">Jednokratna kupnja</span>' +
        '<span class="nutty-po__price">' + money(one) + '</span>' +
      '</label>';

    if (ok) {
      var ustedaPct = Math.round((1 - subSum / one) * 100);
      html +=
        '<label class="nutty-po__opt">' +
          '<input type="radio" name="nutty-mode" value="sub">' +
          '<span class="nutty-po__label">' + (group.name || 'Pretplata') +
            (ustedaPct > 0 ? ' <b class="nutty-po__badge">Uštedi ' + ustedaPct + '%</b>' : '') +
          '</span>' +
          '<span class="nutty-po__price"><s>' + money(one) + '</s> ' + money(subSum) + '</span>' +
        '</label>' +
        '<div class="nutty-po__notes" style="display:none">' +
          '<div class="nutty-po__note">' + (plan.name || '') + ' · ' + sadrzaj +
            (ladder ? ' · ' + ladder : '') + ' · otkaži bilo kada</div>' +
          '<div class="nutty-po__note nutty-po__note--bonus">Osim popusta, pretplata ti donosi i dodatne popuste na akcije, te pokoje iznenađenje.</div>' +
        '</div>';
    }

    box.innerHTML = html;
    form.parentNode.insertBefore(box, form);
    optBox = box;
    box.addEventListener('change', function () {
      [].forEach.call(box.querySelectorAll('.nutty-po__opt'), function (el) {
        el.classList.toggle('is-active', el.querySelector('input').checked);
      });
      var notes = box.querySelector('.nutty-po__notes');
      if (notes) notes.style.display = subSelected() ? '' : 'none';
    });
  }

  document.addEventListener('click', function (e) {
    if (!packForm || !subSelected()) return;
    var t = e.target;
    var btn = t && t.closest ? t.closest('[name="add"], button[type="submit"]') : null;
    if (!btn || !packForm.contains(btn)) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    addPack(activePack, packQty(), btn);
  }, true);

  document.addEventListener('submit', function (e) {
    if (!packForm || e.target !== packForm || !subSelected()) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    addPack(activePack, packQty(), packForm.querySelector('[name="add"]'));
  }, true);

  function packQty() {
    var qi = packForm && packForm.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt(qi && qi.value, 10) || 1);
  }

  function addPack(pack, packs, btn) {
    if (!pack) return;
    if (btn) btn.setAttribute('disabled', 'disabled');
    var props = {}; props[PROP] = pack.title;
    var items = pack.items.map(function (it) {
      return { id: it[0], quantity: it[1] * packs, selling_plan: planId, properties: props };
    });
    nativeFetch(ROOT + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('disabled');
        if (!res.ok) { alert(res.j.description || 'Greška pri dodavanju u košaricu.'); return; }
        refreshCart().then(openDrawer);
      })
      .catch(function () {
        if (btn) btn.removeAttribute('disabled');
        alert('Greška pri dodavanju u košaricu.');
      });
  }

  function openDrawer() {
    ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true }));
    });
    var icon = document.querySelector('[data-cart-drawer-toggle], a[href$="/cart"]');
    if (icon) icon.click();
  }

  /* ---------------- 2. kosarica: zakljucane kolicine ---------------- */

  function refreshCart() {
    return nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; })
      .catch(function () { return null; });
  }

  function locked(item) { return !!(item && item.properties && item.properties[PROP]); }

  function siblings(name) {
    return ((cart && cart.items) || []).filter(function (i) {
      return i.properties && i.properties[PROP] === name;
    });
  }

  function packByTitle(title) {
    for (var h in PACKS) { if (PACKS[h].title === title) return PACKS[h]; }
    return null;
  }

  function perPack(pack, variantId) {
    var q = 0;
    pack.items.forEach(function (it) { if (it[0] === variantId) q = it[1]; });
    return q;
  }

  window.NuttyPack = {
    map: PACKS,
    count: function (title) {
      var pack = packByTitle(title); if (!pack) return 0;
      var items = siblings(title); if (!items.length) return 0;
      var per = perPack(pack, items[0].variant_id);
      return per ? Math.round(items[0].quantity / per) : 0;
    },
    set: function (title, packs) {
      var pack = packByTitle(title);
      if (!pack) return Promise.resolve(null);
      return refreshCart().then(function () {
        var items = siblings(title);
        if (!items.length) return null;
        var ups = {};
        items.forEach(function (line) {
          var per = perPack(pack, line.variant_id);
          ups[line.key] = (packs > 0 && per) ? per * packs : 0;
        });
        return nativeFetch(ROOT + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: ups })
        }).then(function (r) { return refreshCart().then(function () { return r; }); });
      });
    },
    refresh: refreshCart
  };

  function findLine(idOrKey, lineNum) {
    var items = (cart && cart.items) || [];
    if (lineNum) return items[lineNum - 1];
    var s = String(idOrKey);
    for (var i = 0; i < items.length; i++) {
      if (items[i].key === s || String(items[i].variant_id) === s || items[i].key.indexOf(s + ':') === 0) return items[i];
    }
    return null;
  }

  function parseBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      if (body.trim().charAt(0) === '{') { try { return JSON.parse(body); } catch (e) { return null; } }
      var o = {};
      try { new URLSearchParams(body).forEach(function (v, k) { o[k] = v; }); } catch (e) { return null; }
      return o;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var f = {}; body.forEach(function (v, k) { f[k] = v; }); return f;
    }
    return null;
  }

  function bracket(data, name) {
    var out = null;
    Object.keys(data).forEach(function (k) {
      var m = k.match(/^([a-z]+)\[(.+)\]$/);
      if (m && m[1] === name) { out = out || {}; out[m[2]] = data[k]; }
    });
    return out;
  }

  function cartResponse() {
    return new Response(JSON.stringify(cart || {}), {
      status: 200, headers: { 'Content-Type': 'application/json' }
    });
  }

  function removeSet(names) {
    var ups = {};
    names.forEach(function (n) { siblings(n).forEach(function (s) { ups[s.key] = 0; }); });
    return nativeFetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: ups })
    }).then(function (r) { refreshCart(); return r; });
  }

  window.fetch = function (input, init) {
    var url = '', method = 'GET';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
      method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    } catch (e) {}
    if (method !== 'POST' || !/\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      return nativeFetch.apply(null, arguments);
    }
    var args = arguments;
    return refreshCart().then(function () {
      var data = parseBody(init && init.body);
      if (!data) return nativeFetch.apply(null, args);

      if (/\/cart\/update/.test(url)) {
        var ups = data.updates || bracket(data, 'updates');
        if (!ups) return nativeFetch.apply(null, args);
        var toRemove = [], changed = false;
        Object.keys(ups).forEach(function (k) {
          var line = findLine(k);
          if (!locked(line)) return;
          var want = parseInt(ups[k], 10);
          if (want === 0) { toRemove.push(line.properties[PROP]); }
          else if (want !== line.quantity) { ups[k] = line.quantity; changed = true; }
        });
        if (toRemove.length) return removeSet(toRemove);
        if (changed) {
          return nativeFetch(ROOT + 'cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: ups })
          }).then(function (r) { refreshCart(); return r; });
        }
        return nativeFetch.apply(null, args).then(function (r) { refreshCart(); return r; });
      }

      var target = findLine(data.id, data.line ? parseInt(data.line, 10) : 0);
      if (!locked(target)) return nativeFetch.apply(null, args).then(function (r) { refreshCart(); return r; });
      var q = parseInt(data.quantity, 10);
      if (q === 0) return removeSet([target.properties[PROP]]);
      return cartResponse();
    });
  };

  /* ---------------- 3. zakljucavanje u temi (cart stranica) ---------------- */

  function lockDom() {
    [].forEach.call(document.querySelectorAll('.cart-item'), function (row) {
      if (row.dataset.nuttyLocked) return;
      if (row.textContent.indexOf(PROP + ':') === -1) return;
      row.dataset.nuttyLocked = '1';
      row.classList.add('nutty-locked');
    });
  }

  function boot() {
    initPdp();
    refreshCart();
    lockDom();
    try {
      new MutationObserver(function () { initPdp(); lockDom(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
